import { useQuery } from '@apollo/client';
import React, { useEffect, useLayoutEffect, useMemo } from 'react';
import Container from '~/components/Container';
import Text from '~/components/Text';
import { QUERY_PRODUCT_TAGS } from '~/data/product/gql';

type Props = {
    sku: string;
};

const ProductTags = (props: Props) => {
    const [isObserver, setIsObserver] = React.useState(false);
    const productTagRef = React.useRef<HTMLDivElement>(null);
    const { data } = useQuery(QUERY_PRODUCT_TAGS, {
        variables: {
            sku: props.sku
        },
        skip: !isObserver
    });
    const dataTags: {
        name: string;
        url_key: string;
    }[] = useMemo(() => {
        if (!data) return [];
        return data?.products?.items?.[0].product_tags || [];
    }, [data]);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                setIsObserver(true);
            }
        });
        if (!isObserver && productTagRef.current) {
            observer.observe(productTagRef.current);
        }
        return () => {
            if (productTagRef.current) {
                observer.unobserve(productTagRef.current);
            }
        };
    }, [productTagRef]);

    return (
        <div ref={productTagRef}>
            <Container>
                {!!dataTags?.length && (
                    <Text className="mb-4 font-semibold text-xl lg:text-3xl">Explore more related searches</Text>
                )}
                {!!dataTags?.length &&
                    dataTags?.map((item, index) => (
                        <a
                            key={index}
                            href={`/${item.url_key}`}
                            className="inline-block bg-gray-200 text-gray-700 rounded-full lg:px-3 px-2 lg:py-2 py-1 font-semibold mb-2 mr-2
              hover:bg-gray-300 lg:text-lg text-sm
            "
                        >
                            {item.name}
                        </a>
                    ))}
            </Container>
        </div>
    );
};

export default ProductTags;
